import React, { useState } from "react";
import { Button, Steps, Popover } from "antd";

const StepPanel = (props) => {
  const [activeStep, setActiveStep] = useState(0);

  function next() {
    const nextStep = activeStep + 1;
    setActiveStep(nextStep);
  }

  function prev() {
    const prevStep = activeStep - 1;
    setActiveStep(prevStep);
  }
  const customDot = (dot, { status, index }) => (
    <Popover
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );
  return (
    <>
      <Steps
        current={activeStep}
        progressDot={customDot}
        style={{ marginTop: "1%" }}
      >
        {props.steps.map((item) => (
          <Steps.Step
            key={item.title}
            title={item.title}
            description={item.description}
          />
        ))}
      </Steps>
      <div className="mt-3">{props.steps[activeStep].content}</div>
      <div className="mt-3 ml-5 col-md-3 mx-auto">
        {activeStep > 0 && (
          <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
            ย้อนกลับ
          </Button>
        )}
        {activeStep < props.steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            ถัดไป
          </Button>
        )}
        {activeStep === props.steps.length - 1 && (
          <Button type="primary" htmlType="submit">
            บันทึก
          </Button>
        )}
      </div>
    </>
  );
};

export { StepPanel };
